
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { IAggregateResultHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import { performance } from '../../shared/services/PerformanceService';
import store from '../../store/store';
import OverviewBase from './OverviewBase.vue';

@Component({})
export default class TribeOverview extends OverviewBase {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track('Tribe Dashboard');
        await store.dispatch('aggregate/fetchTribesAggregate');
        next();
    }

    protected get aggregate(): IAggregateResultHypermediaRepresentation {
        return this.aggregateState.tribesAggregate;
    }

    protected get title(): string {
        return 'Tribe Dashboard';
    }

    protected get placeholder(): string {
        return 'Search on hive - tribe';
    }

    public goToDetails(id: string, name: string) {
        this.$router.push({ name: 'tribeDetails', params: { id } });
    }
}
